"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cSetBrandThemeStyleBodySchema = exports.cStyleRuleAndValueSchema = exports.cStyleSourceSchema = exports.cStyleRuleOptionSchema = void 0;
var zod_1 = require("zod");
var constants_1 = require("./constants");
exports.cStyleRuleOptionSchema = zod_1.z.enum(constants_1.cStyleRuleOptions);
exports.cStyleSourceSchema = zod_1.z.enum([
    'customCSS',
    'designPanel',
    'global'
]);
exports.cStyleRuleAndValueSchema = zod_1.z.object({
    /** Primary key - Converts into CSS variable */
    rule: exports.cStyleRuleOptionSchema,
    /** Current value set by admin/user. CSS value for variable */
    value: zod_1.z.string().optional(),
    /** Original value from the theme.json */
    originalValue: zod_1.z.string().optional(),
    /** CSS variable converted from Rule */
    cssVar: zod_1.z.string().optional(),
});
exports.cSetBrandThemeStyleBodySchema = zod_1.z.object({
    styles: exports.cStyleRuleAndValueSchema.array()
});
